import React, { useState } from "react";
import { LoadingIcon, Button } from '@prosolve/common-components-ui'
import { FaPlus } from 'react-icons/fa';
import UserCard from "../../../UserCard/UserCard";
import AddTrainerModal from "./AddTrainerModal";
import DeleteTrainerModal from "./DeleteTrainerModal";
import { checkHasEditEventPermissions, getClientSubdomain } from '../../../../utils';
import useIsMobileView from "../../../../hooks/useIsMobileView";

export default ({
  eventData,
  trainers,
  isLoading,
  isLead = false,
  onTrainersUpdated
}) => {
  const isMobileView = useIsMobileView();

  const hasEditPermissions = checkHasEditEventPermissions();

  const isStar = getClientSubdomain() === 'star'

  const plural = (word, plural) => {
    return (trainers.length <= 1 ? word : plural)
  }

  const attendeeTitle = `
    ${!isStar ? `Trainer${plural('', 's')} Attending`
      : Boolean(isLead) ? `Lead Trainer${plural('', 's')}`
      : `Support Trainer${plural('', 's')}`
    }
    ${(trainers.length <= 1) ? ''
      : `(${isLoading ? '.' : trainers.length})`
    }`

  const [addNewTrainerOpen, setAddNewTrainerOpen] = useState(false)

  const [deleteTrainerObj, setDeleteTrainerObj] = useState()

  const onAddNewTrainer = () => {
    setAddNewTrainerOpen(true)
  }

  const onAddNewTrainerSuccess = () => {
    setAddNewTrainerOpen(false)
    onTrainersUpdated({ eventId : eventData.id })
  }

  const onDeleteTrainerClicked = (trainerId) => {
    setDeleteTrainerObj({ trainerId, eventId : eventData.id })
  }

  const onDeleteTrainerSuccess = () => {
    setDeleteTrainerObj(undefined)
    onTrainersUpdated({ eventId : eventData.id })
  }

  return (
    <div
      style={{
        width: isMobileView ? 'calc(100vw - 50px)' : 'auto',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {
        addNewTrainerOpen &&
        <AddTrainerModal 
          eventId={eventData.id}
          onClose={() => setAddNewTrainerOpen(false)}
          onSuccess={onAddNewTrainerSuccess}
          isLead={isLead}
        />
      }
      {
        Boolean(deleteTrainerObj) &&
        <DeleteTrainerModal 
          trainer={deleteTrainerObj}
          onClose={() => setDeleteTrainerObj(undefined)}
          onSuccess={onDeleteTrainerSuccess}
        />
      }
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}>
        <div style={{
          flex: 1,
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          marginLeft: '20px'
        }}>
          {attendeeTitle}
        </div>
        {
          hasEditPermissions &&
          <Button
            style={{
              display: 'inline-flex',
              padding: '8px 16px',
              marginRight: '20px'
            }}
            onClick={onAddNewTrainer}
          >
            <FaPlus style={{ marginRight: '10px', color: '#0280c6' }} />
            <span style={{ fontWeight: 'bold', color: '#565656'}}>{'Add Trainer'}</span>
          </Button>
        }
      </div>
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: isMobileView ? 'column' : 'row',
            columnGap: '20px',
            rowGap: '20px',
            padding: '20px',
            flexWrap: 'wrap'
          }}>
            {trainers.length > 0
              ?
              trainers.map(trainer => {
                const {
                  id = '',
                  name = '',
                  email = '',
                  phone = '',
                  requestStatus = ''
                } = trainer;
                return <UserCard key={id} id={id} name={name} email={email} phone={phone} requestStatus={requestStatus} onDelete={onDeleteTrainerClicked} />
              })
              :
              <div>None assigned</div>
            }
          </div>
      }
    </div>
  )
}